'use client'

import { Icon } from '@components/primitives/Icon'
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons/faLocationDot'
import { useToggleMapView } from '@modules/trials/search/map/toggleMapView'
import Image from 'next/image'
import { MAPTILER_API_TOKEN } from '../LocationMap/consts'

export default function MapCTA({
  activeLocationLabel,
  latitude,
  longitude,
}: {
  activeLocationLabel?: string
  latitude: number
  longitude: number
}) {
  const staticMapURL = `https://api.maptiler.com/maps/basic-v2/static/${longitude},${latitude},10/320x134@2x.jpg?key=${MAPTILER_API_TOKEN}`
  const toggleMapView = useToggleMapView()

  return (
    <div className='relative mb-6 flex h-[134px] w-80 items-center justify-center rounded-lg border-[1.5px] border-neutral200'>
      <div
        className='absolute left-1/2 z-10 mb-6 flex h-[52px] w-[167px] -translate-x-1/2 cursor-pointer items-center justify-center gap-2 rounded-lg bg-black/80 transition-all hover:bg-black hover:shadow-lg'
        onClick={() => toggleMapView(false)}
      >
        <Icon className='text-white' icon={faLocationDot} />
        <span className='select-none text-sm font-bold leading-normal text-white antialiased'>
          Show Map
        </span>
      </div>
      <Image
        alt='Map View'
        className='animate-pulse select-none bg-neutral200'
        fill
        priority={true}
        src={staticMapURL}
        style={{
          borderRadius: '7px',
          objectFit: 'cover',
          opacity: 0.5,
        }}
      />
      <div className='absolute bottom-0 flex h-6 w-full items-center justify-center rounded-b-lg bg-neutral50'>
        <span className='select-none text-xs font-semibold leading-normal'>
          {activeLocationLabel ?? 'Your Location'}
        </span>
      </div>
    </div>
  )
}
